import React, { useMemo } from 'react';
import { DropzoneRootProps, DropzoneState } from 'react-dropzone';
import styled from 'styled-components';

export interface FileDropzoneProps extends DropzoneState {
  overlayVisible?: boolean;
}

export function FileDropzone({
  overlayVisible,
  isFocused,
  isDragAccept,
  isDragReject,
  getRootProps,
  getInputProps,
}: FileDropzoneProps) {
  const style: DropzoneRootProps = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject],
  );

  if (!overlayVisible) return null;

  return (
    <DropzoneWrapper {...getRootProps({ style })}>
      <input {...getInputProps()} />
      <span>Drop files here to add it to the conversation</span>
    </DropzoneWrapper>
  );
}

const DropzoneWrapper = styled.div`
  position: fixed;
  z-index: 100;
  height: 100%;
  width: 100%;
  inset: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  span {
    color: #373737;
    font-size: 1.8rem;
    font-weight: 500;
    text-align: center;
    padding: 10px;
    font-family: Eesti, sans-serif;
  }
`;

const baseStyle = {
  backgroundColor: `rgba(33, 174, 234, 0.2)`,
  backdropFilter: `blur(8px)`,
};

const focusedStyle = {
  backgroundColor: `rgba(0, 0, 0, 0.1)`,
};

const acceptStyle = {};

const rejectStyle = {
  backgroundColor: `rgb(248, 101, 101, 0.2)`,
};
